import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { SessionProvider } from './session.tsx';
import './styles/fonts.css';
import './styles/tokens.css';
import './styles/base.css';

const root = document.getElementById('root');
if (root === null) throw new Error('#root отсутствует в index.html');

createRoot(root).render(
  <StrictMode>
    <SessionProvider>
      <App />
    </SessionProvider>
  </StrictMode>,
);
